import React from 'react';
import { HeroBannerCarouselStyles as S } from './HeroBannerCarousel.styles';
import { MotionConfig } from 'framer-motion';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import CarouselSlide from './CarouselSlide/CarouselSlide';
import LiveRegion from '@stories/Components/Carousels/Carousel/LiveRegion/LiveRegion';
import Connected from '@stories/Components/Carousels/Carousel/Connected/Connected';
import { withMotionMax } from '@hoc/withMotionMax';
import DotPagination from '@stories/Components/Global/DotPagination/DotPagination';
import { useAutoplay } from '@hooks/useAutoplay';
const HeroBannerCarousel = ({ items, autoplay = 0, paginationAriaLabel }) => {
    const { activeIndex, duration, paused, setActiveIndex, setPaused } = useAutoplay({
        enabled: autoplay > 0,
        duration: autoplay,
        items,
    });
    React.useEffect(() => {
        setPaused(false);
    }, []);
    return (React.createElement(MotionConfig, { transition: { duration: 0.45, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { count: items.length },
            React.createElement(S.Container, null,
                React.createElement(LiveRegion, null),
                React.createElement(S.Track, { trackMutations: true, onSwipeChange: (index) => setActiveIndex(index) }, items.map((item, i) => (React.createElement(S.Item, { key: `${item.title} - ${i}` },
                    React.createElement(CarouselSlide, { ...item, slideIndex: i }))))),
                React.createElement(Connected, null, (carousel) => (React.createElement(S.PaginationWrapper, null, items.length > 1 &&
                    React.createElement(S.Pagination, null,
                        React.createElement(DotPagination, { ariaLabel: paginationAriaLabel, count: carousel.maxIndex + 1, value: activeIndex, paused: paused, onAutoUpdate: (index) => {
                                carousel.goToIndex(index);
                                setActiveIndex(index);
                            }, onChange: (index) => {
                                carousel.goToIndex(index);
                                setActiveIndex(index);
                                setPaused(true);
                            }, autoplay: duration, showPlayControls: false })))))))));
};
export default withMotionMax(HeroBannerCarousel);
